// value는 url path 이름과 같게 입력해야함 === router.route.substr(1)
// [id]처럼 파라미터로 추가한 이름은 반드시 PageInfo에 같은 이름으로 존재해야 한다.
export enum Page {
  Home = '[[...home]]',
  NotSupported = 'not-supported',
  MyPageItemList = 'my-page/item-list',
  MyPageEpisodeList = 'my-page/episode-list',
  Event = 'event',
  DebugLog = 'debug-log',
  Content = 'content/[sid]/[id]',
  ContentTicketHistory = 'content/[sid]/[id]/ticket-history',
  ContentTicketRefund = 'content/[sid]/[id]/ticket-history/refund',
  ContentNotice = 'content/[sid]/[id]/notice',
  ContentPurchase = 'content/[sid]/[id]/purchase',
  ContentKeyword = 'content/keyword',
  Search = 'search',
  Dev = 'dev',
  DevSsrError = 'dev/ssr-error',
  Luckydraw = 'luckydraw',
  LuckydrawEnterinfo = 'luckydraw/enter-info',
  LuckydrawRaffle = 'raffle',
  More = 'more',
  MoreCouponRegister = 'more/coupon-register',
  MoreFaq = 'more/faq',
  MoreNotice = 'more/notice',
  MoreMyNews = 'more/my-news',
  MoreWaitfreeNotification = 'more/waitfree-notification',
  MoreSetting = 'more/setting',
  MoreSettingThirdParty = 'more/setting/third-party',
  MoreCashHistory = 'more/cash-history',
  MoreDaumCashHistory = 'more/daum-cash-history',
  MoreCashReceiptInfo = 'more/cash-receipt/info',
  MoreCashReceiptDetail = 'more/cash-receipt/detail',
  MoreCashReceiptRegister = 'more/cash-receipt/register',
  MoreCashPassInfo = 'more/cash-pass-info',
  MoreCashPassInfoDetail = 'more/cash-pass-info/detail',
  MoreTicketHistory = 'more/ticket-history',
  MoreCashPurchase = 'more/cash-purchase',
  MoreAutoCashPurchase = 'more/auto-cash-purchase',
  MoreAutoCashPurchaseComplete = 'more/auto-cash-purchase/complete',
  MoreCustomerCenter = 'more/customer-center',
  MoreServiceInformation = 'more/customer-center/service-information',
  MoreRightReport = 'more/customer-center/right-report',
  MoreInquiry = 'more/customer-center/inquiry',
  MoreBusiness = 'more/customer-center/service-information/business',
  MorePolicy = 'more/customer-center/service-information/policy',
  MorePolicyTerms = 'more/customer-center/service-information/policy/terms',
  MorePolicyTermsKor20210801 = 'more/customer-center/service-information/policy/terms/2021-08-01',
  MorePolicyTermsKor20221021 = 'more/customer-center/service-information/policy/terms/2022-10-21',
  MorePolicyTermsKorRevision = 'more/customer-center/service-information/policy/terms/revision',
  MorePolicyPaidTerms = 'more/customer-center/service-information/policy/paid-terms',
  MorePolicyPaidTermsKor20220630 = 'more/customer-center/service-information/policy/paid-terms/2022-06-30',
  MorePolicyPaidTermsKor20221021 = 'more/customer-center/service-information/policy/paid-terms/2022-10-21',
  MorePolicyPaidTermsKorRevision = 'more/customer-center/service-information/policy/paid-terms/revision',
  MorePolicyPaymentManagement = 'more/customer-center/service-information/policy/payment-management',
  MorePolicyPersonalInformation = 'more/customer-center/service-information/policy/personal-information',
  MorePolicyPersonalInformationKor20210801 = 'more/customer-center/service-information/policy/personal-information/2021-08-01',
  MorePolicyPersonalInformationKor20211115 = 'more/customer-center/service-information/policy/personal-information/2021-11-15',
  MorePolicyPersonalInformationKor20220530 = 'more/customer-center/service-information/policy/personal-information/2022-05-30',
  MorePolicyCookieTerms = 'more/customer-center/service-information/policy/cookie-terms',
  MorePolicyPersonalThirdParty = 'more/customer-center/service-information/policy/personal-third-party',
  MorePolicyLimit14 = 'more/customer-center/service-information/policy/limit-14',
  MorePersonalInformationShort = 'more/customer-center/service-information/policy/personal-information-short',
  MorePolicyManagement = 'more/customer-center/service-information/policy/management',
  MorePolicyAdvertisement = 'more/customer-center/service-information/policy/advertisement',
  MorePolicyYouth = 'more/customer-center/service-information/policy/youth',
  MorePolicyChildPersonalThirdParty = 'more/customer-center/service-information/policy/child-personal-third-party',
  MorePolicyLegalRepresentative = 'more/customer-center/service-information/policy/legal-representative',
  MorePolicyChildPersonalInformation = 'more/customer-center/service-information/policy/child-personal-information',
  MoreMyInformation = 'more/my-information',
  MoreMyInformationChangeNickname = 'more/my-information/change-nickname',
  MoreMyInformationServiceWithdrawal = 'more/my-information/service-withdrawal',
  Viewer = 'viewer/[sid]/[id]',
  Special = 'special/[id]',
  WebviewNotice = 'webview/notice',
  AddedCashReceipt = 'more/added-cash-receipt',
  AuthTerms = 'auth/terms',
  AuthOAuth = 'auth/oauth',
  AuthIntegration = 'auth/integration',
  LinkApp = 'linkapp',
  Gift = 'gift',
}
